export default __webpack_public_path__ + "static/media/icon-truck-orange.347faa48.jpg";